import * as angular from 'angular';
import * as _ from 'lodash';

import { AlarmLevel, ApplicationUserViewModel, EmailEventType, IApprovalStrategy, TicketStatusId, TriggerType, WorkflowTriggerDTO, WorkflowType } from '../../models/';
import { PossibleIcons } from './cells/PossibleIcons';
import { DisplayInfo } from './DisplayInfo';
import { wideService } from '../../common/constants';

export interface IWorkflowOverviewStateService {
    getTriggerDisplayInfo(dto: WorkflowTriggerDTO,
        users: _.Dictionary<ApplicationUserViewModel>,
        approvalStrategies: _.Dictionary<IApprovalStrategy>): DisplayInfo;
}

export class WorkflowOverviewStateService implements IWorkflowOverviewStateService {

    static serviceId = 'workflowOverviewStateService';
    static $inject = ['$filter', '$translate'];
    constructor(private _$filter: angular.IFilterService,
        private _$translate: angular.translate.ITranslateService) {
    }

    getTriggerDisplayInfo(dto: WorkflowTriggerDTO,
        users: _.Dictionary<ApplicationUserViewModel>,
        approvalStrategies: _.Dictionary<IApprovalStrategy>): DisplayInfo {
        const cron: (arg: string) => string = this._$filter('cron');
        const icon: PossibleIcons = {
            colorClass: 'success'
        };
        let content: string;
        let approvalLevels: number[];
        let user: ApplicationUserViewModel;

        if (dto) {
            user = users[dto.userId];
            const luser = dto.userId?.toLowerCase() ?? '';
            const strategy = approvalStrategies[dto.approvalStrategyGuid];

            switch (dto.type) {
                case WorkflowType.Task:
                    if (luser.indexOf(wideService.toLowerCase()) >= 0) {
                        content = `${this.$t('Online job')}`;
                        icon.isClock = true;
                    }
                    else if (luser.indexOf('trigger ') >= 0) {
                        content = `${this.$t('Trigger')} ${dto.userId.substring(8)}`;
                        icon.isClock = true;
                    }
                    else {
                        //if launched by user: fa-user 
                        //  + user "display" name 
                        //  + user smart tool tip (case where user has launched tasks manually, bulk inserted data, manual inputs(incl bulk input, validation)
                        icon.isUser = true;
                    }
                    break;
                case WorkflowType.TriggerAction:
                    content = dto.name;
                    switch (dto.triggerType) {
                        case TriggerType.OnlineJobCompleted:
                        case TriggerType.Schedule:
                            icon.isClock = true;
                            break;
                        case TriggerType.QualityIssue:
                            icon.isQuality = true;
                            break;
                    }
                    break;
                case WorkflowType.EventMail:
                    switch (dto.emailEventType) {
                        case EmailEventType.AlarmRaised:
                            content = this.$t('Alarm raised');
                            icon.isAlarm = true;
                            switch (dto.severity) {
                                case AlarmLevel.Information:
                                    icon.colorClass = 'info';
                                    break;
                                case AlarmLevel.Warning:
                                    icon.colorClass = 'warning';
                                    break;
                                case AlarmLevel.Critical:
                                    icon.colorClass = 'error';
                                    break;
                            }
                            break;
                        case EmailEventType.Approval:
                            icon.isApproval = true;
                            if (strategy) {
                                content = strategy.name;
                                approvalLevels = dto.approvalLevels;
                            }
                            break;
                        case EmailEventType.Rejection:
                            icon.isRejection = true;
                            if (strategy) {
                                content = strategy.name;
                                approvalLevels = dto.approvalLevels;
                            }
                            break;
                        case EmailEventType.TicketStatuses:
                            icon.isTicket = true;
                            if (dto.ticketStatuses?.length > 0) {
                                content = dto.ticketStatuses.map(s => {
                                    return this.$t(TicketStatusId[s]);
                                }).join(', ');
                            }
                            else {
                                content = this.$t('Status change');
                            }
                    }
                    break;
                case WorkflowType.OnlineJob:
                    content = `${this.$t('Online job')} ${dto.frequency}`;
                    icon.isClock = true;
                    break;
                case WorkflowType.ScheduledMail:
                    content = this.$t(cron(dto.frequency));
                    icon.isCalendar = true;
                    break;
            }

            if (dto.isDisabled) {
                icon.colorClass = 'disabled';
            }
        }

        return {
            approvalLevels,
            content,
            icon,
            user
        };
    }

    private $t(str: string): string {
        return this._$translate.instant(str);
    }

}